import React from 'react';
import { Link } from 'react-router-dom';

// Desktop Login — centred card.
export default function LoginDesktop({ vm }) {
  const { mobile, setMobile, password, setPassword, remember, setRemember, busy, err, autoChecking, submit } = vm;

  if (autoChecking) {
    return (
      <div className="center-screen">
        <div className="card" style={{ width: '100%', maxWidth: 380 }}>
          <div className="card-pad" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 24, fontWeight: 800, color: 'var(--brand)' }}>Mehfil by Smartify</div>
            <div className="muted" style={{ marginTop: 12, fontSize: 13 }}>Signing you in…</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="center-screen">
      <div className="card" style={{ width: '100%', maxWidth: 380 }}>
        <div className="card-pad" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 24, fontWeight: 800, color: 'var(--brand)' }}>Mehfil by Smartify</div>
          <div className="muted" style={{ marginBottom: 18, fontSize: 13 }}>Event organiser sign in</div>
          <form onSubmit={submit} style={{ textAlign: 'left' }}>
            <label className="field">Mobile Number
              <input type="tel" maxLength={10} value={mobile} placeholder="10-digit mobile"
                onChange={(e) => setMobile(e.target.value)} />
            </label>
            <label className="field">Password
              <input type="password" value={password} placeholder="Password"
                onChange={(e) => setPassword(e.target.value)} />
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, marginBottom: 12 }}>
              <input type="checkbox" checked={remember} style={{ width: 'auto' }}
                onChange={(e) => setRemember(e.target.checked)} />
              Keep me signed in on this device
            </label>
            {err && <div style={{ color: 'var(--danger)', fontSize: 13, marginBottom: 10 }}>{err}</div>}
            <button className="btn primary" style={{ width: '100%' }} disabled={busy}>
              {busy ? 'Signing in…' : 'Sign In'}
            </button>
          </form>
          <div className="muted" style={{ marginTop: 14, fontSize: 13 }}>
            New here? <Link to="/register">Create an account</Link>
          </div>
          <div className="muted" style={{ marginTop: 8, fontSize: 13, borderTop: '1px solid var(--line)', paddingTop: 10 }}>
            Are you a guest? <Link to="/invite">View your invitation</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
